import React from "react";
import { toast } from "react-toastify";
import 'bootstrap/dist/css/bootstrap.min.css';
import '../css/App.css'


class UpdateVendor extends React.Component {

    constructor(props) {
        super(props);    
        this.state = {          
          vendorId:'',
          vendorName: null,
          factoryAddress: '',
          nextPoNumber: '',
          poPrefix: '',
          shippingTerms: '',
          paymentTerms: '',
          shippingMethod: '',
               };     

        this.updateVendor = this.updateVendor.bind(this);
        this.handleChange = this.handleChange.bind(this);
        
    }
    
componentDidMount = () => {
  console.log("data===",this.props.data)
  const result = this.props.data;

  console.log("resutl+++++++++" ,result)

  this.setState({ vendorId: result.id })
  this.setState({ vendorName: result.vendorName })
  this.setState({ factoryAddress: result.factoryAddress })
  this.setState({ nextPoNumber: result.nextPoNumber })
  this.setState({ poPrefix: result.poPrefix })
  this.setState({ shippingTerms: result.shippingTerms })
  this.setState({ paymentTerms: result.paymentTerms })
  this.setState({ shippingMethod: result.shippingMethod })
  
 
}


handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });

}

// update vendors 

updateVendor=async(e)=>  {
    e.preventDefault();

     const { vendorId, vendorName, factoryAddress, nextPoNumber, poPrefix, shippingTerms, paymentTerms, shippingMethod } = this.state;

    const formData = new FormData();
   // const vendorId = this.props.match.params.id;

    formData.append("vendorId",vendorId)
    formData.append("vendorName", vendorName);
    formData.append("factoryAddress", factoryAddress);
    formData.append("nextPoNumber", nextPoNumber);
    formData.append("poPrefix", poPrefix);
    formData.append("shippingTerms", shippingTerms);
    formData.append("paymentTerms", paymentTerms);
    formData.append("shippingMethod", shippingMethod);

    const requestOptions = {
      method: 'POST',
      body: formData,
    };

   const response= await fetch(`https://dashboard.realsexdoll.info/php/vendors/updatevendor.php`, requestOptions)

   const result = await response.text();

   toast.success('Vendor updated successfully');

   window.location.reload();
  
   console.log(result)

   

    
  // toast.success('Vendor updated successfully');
      // .then((response) => 
      // console.log(response.text()),
      // // console.log(response.text()),
      // toast.success('Vendor updated successfully')
      // )
      // .then(() => {
       
      //   // Redirect to the vendor list or wherever you want after the update
      // // this.props.history.push("/vendors/vendorlist");
      // })
       .catch((error) => console.error('Error updating vendor:', error));
  }

  render() {
    
    return(

<div class="modal show fade d-block" tabindex="-1" >
  <div class="modal-dialog modal-dialog-centered">
  <form onSubmit={this.updateVendor}>
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Update Vendor</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => this.props.handleClose()}></button>
      </div>
      <div class="modal-body">
      
      <div className="row">

<div className="col-6">
<label for="exampleFormControlInput1" class="form-label">Vendor Name</label>
<input type="text" class="form-control mb-4" id="exampleFormControlInput1"  onChange={this.handleChange}  name="vendorName"   value={this.state.vendorName} required/>
</div>


<div className="col-6">
<label for="exampleFormControlInput1" class="form-label">Factory Address</label>
<input type="text" class="form-control mb-4" id="exampleFormControlInput1"  onChange={this.handleChange}  name="factoryAddress"   value={this.state.factoryAddress} required/>
</div>

<div className="col-6">
<label for="exampleFormControlInput1" class="form-label">Next PONumber</label>
<input type="text" class="form-control mb-4" id="exampleFormControlInput1"  onChange={this.handleChange}  name="nextPoNumber"   value={this.state.nextPoNumber} required/>
</div>

<div className="col-6">
<label for="exampleFormControlInput1" class="form-label">Po Prefix</label>
<input type="text" class="form-control mb-4" id="exampleFormControlInput1"  onChange={this.handleChange}  name="poPrefix"   value={this.state.poPrefix} required/>
</div>
<div className="col-6">
<label for="exampleFormControlInput1" class="form-label">Shipping Terms</label>
<input type="text" class="form-control mb-4" id="exampleFormControlInput1"  onChange={this.handleChange}  name="shippingTerms"   value={this.state.shippingTerms} required/>
</div>


<div className="col-6">
<label for="exampleFormControlInput1" class="form-label">Payment Terms</label>
<input type="text" class="form-control mb-4" id="exampleFormControlInput1"  onChange={this.handleChange}  name="paymentTerms"   value={this.state.paymentTerms} required/>
</div>


<div className="col-6">
<label for="exampleFormControlInput1" class="form-label">Shipping Method</label>
<input type="text" class="form-control mb-4" id="exampleFormControlInput1"  onChange={this.handleChange}  name="shippingMethod"   value={this.state.shippingMethod} required/>
</div>

</div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" data-bs-dismiss="modal" onClick={() => this.props.handleClose()}>Close</button>
        <button type="submit"  class="btn btn-primary" >Save </button>
      </div>
     
    </div>
    </form>
  </div>
</div>

     
    )

  }
}

export default UpdateVendor;
